import {combineReducers} from 'redux';
import account from '../../account/reducer/accountReducer';
import club from '../../club/reducer/clubReducer';
import navigation from '../../common/reducer/navigation';
import i18n from '../../i18n/reducer/i18nReducer';
import message from '../../message/reducer/messageReducer';
import training from '../../training/reducer/trainingReducer';
import loader from './loaderReducer';

export default combineReducers({
    i18n,
    loader,
    account,
    message,
    navigation,
    training,
    club
});
